import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initOffice } from './hooks/useOffice'
import './i18n'
import './index.css'
import App from './App'

/**
 * KobSign Word Add-in entry point.
 *
 * Renders React immediately, then initializes Office.js in background.
 * This prevents a blank screen if Office.onReady() hangs.
 */

// Render React first — app will show loading state via useOffice hook
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Initialize Office.js in background (notifies hooks when ready)
initOffice()
